var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#43C59E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4312 25.286H24.4043C23.6914 25.286 23.1137 24.7079 23.1137 23.9952V21.8513C23.1137 21.1383 23.6914 20.5607 24.4043 20.5607H28.4312V18.557C28.4312 17.612 27.6654 16.8463 26.7209 16.8463H14.7103C13.7657 16.8463 13 17.612 13 18.557V27.2893C13 28.2343 13.7657 29 14.7103 29H26.7209C27.6654 29 28.4312 28.2343 28.4312 27.2893V25.286Z",
    fill: "#43C59E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4695 14.145L25.8674 16.3379H16.3909L25.4695 14.145Z",
    fill: "#43C59E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0141 14.1487L17.8634 15.6335L23.5614 13L24.0141 14.1487Z",
    fill: "#43C59E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0536 24.7773H24.4043C23.9725 24.7773 23.6226 24.4277 23.6226 23.9953V21.8513C23.6226 21.419 23.9725 21.0694 24.4043 21.0694H29.0536V24.7773ZM25.9475 22.9231C25.9475 22.5677 25.6589 22.2791 25.3032 22.2791C24.9476 22.2791 24.6592 22.5677 24.6592 22.9231C24.6592 23.2788 24.9476 23.5674 25.3032 23.5674C25.6589 23.5674 25.9475 23.279 25.9475 22.9231Z",
    fill: "#43C59E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.f2e91ecb63d0373d0a667e9e3042c437.svg";
export { ForwardRef as ReactComponent };